import { FC, useEffect } from 'react'
import styled from 'styled-components'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { saveState } from 'components/Common/Tutorial/_methods'
import TutorialButton from 'components/Common/Tutorial/TutorialButton'
import { useCompleteTutorial } from 'components/Pages/Retail/GeoIndications/Tutorial/TutorialDialog/_methods'
import TutorialDialog from 'components/Pages/Retail/GeoIndications/Tutorial/TutorialDialog'
import { getIsTutorialActive, setCurrentStep, setSteps } from 'store/tutorial'
import { useGetTutorialSteps, useTutorialAutoStart } from './_methods'
import { TutorialData } from 'components/Common/Menu'

const Wrapper = styled.div`
  box-sizing: border-box;
  height: 48px;
  min-height: 48px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--color-night);
  margin-right: 12px;
`

interface TutorialProps {
  data: TutorialData
}

const Tutorial: FC<TutorialProps> = ({ data }) => {
  if ('aside' in data) {
    return null
  }
  const dispatch = useAppDispatch()
  const { completeTutorial } = useCompleteTutorial()
  const isTutorialActive = useAppSelector(getIsTutorialActive)
  const steps = useGetTutorialSteps()

  useEffect(() => {
    dispatch(setSteps(data.steps))
  }, [steps])

  useTutorialAutoStart(data.page)

  const openTutorial = () => {
    dispatch(setCurrentStep(0))
  }
  const handleFinish = async () => {
    await completeTutorial(data.page)
    saveState(data.page, 0)
    dispatch(setCurrentStep(null))
  }

  return (
    <>
      <Wrapper>
        <TutorialButton onClick={openTutorial} />
      </Wrapper>

      {isTutorialActive && (
        <TutorialDialog
          onClose={step => {
            saveState(data.page, step)
            dispatch(setCurrentStep(null))
          }}
          onFinish={handleFinish}
        />
      )}
    </>
  )
}

export default Tutorial
